import classnames from 'classnames';
import React, { isValidElement, ReactElement } from 'react';

import * as styles from './table.module.scss';

import { SortingOptions } from './Sorting/types';
import TableBody from './TableBody';
import TableCell from './TableCell';
import TableHead from './TableHead';
import TableRow from './TableRow';
import { ColumnConfig } from './type';

export interface TableProps {
  columns: ColumnConfig[];
  rows?: ReactElement[][];
  isHeaderSticky?: boolean;
  isFirstColumnSticky?: boolean;
  defaultSortingOptions?: SortingOptions;
  sortingOptions?: SortingOptions;
  setSortingOptions?: (options: SortingOptions) => void;
  onRender?: (ref: any) => void;
  className?: string;
  dontWrap?: boolean;
  tableBorder?: boolean;
  highlightedRows?: number[];
  children?: React.ReactNode;
}

const Table: React.FC<TableProps> = (props) => {
  const {
    columns,
    rows,
    isHeaderSticky,
    isFirstColumnSticky,
    defaultSortingOptions,
    sortingOptions,
    setSortingOptions,
    onRender,
    dontWrap,
    tableBorder,
    highlightedRows,
  } = props;

  let children = props.children;

  if (rows) {
    children = rows.map((row: ReactElement[], rowIndx: number) => {
      const highlightRow = highlightedRows && highlightedRows.includes(rowIndx + 1);

      return (
        <TableRow key={`table-row-${rowIndx}`} isFirstColumnSticky={isFirstColumnSticky} isHighlighted={highlightRow}>
          {row.map((field: ReactElement, colIndx: number) => {
            const sortedCell = isValidElement(field) && sortingOptions?.headerKey === (field?.props as any)?.columnKey;
            return <TableCell key={`field-${colIndx}`} content={field} isSorted={sortedCell} />;
          })}
        </TableRow>
      );
    });
  }

  return (
    <table className={classnames(styles.Table, props.className)}>
      <TableHead
        onRender={onRender}
        columns={columns}
        isFirstColumnSticky={isFirstColumnSticky}
        isHeaderSticky={isHeaderSticky}
        sortingOptions={sortingOptions}
        setSortingOptions={setSortingOptions}
        defaultSortingOptions={defaultSortingOptions}
      />
      {dontWrap ? children : <TableBody bordered={tableBorder}>{children}</TableBody>}
    </table>
  );
};

export default Table;
